import React from 'react';
import Dialog from '@teetsh/app/src/components/Dialog';
import Img from '@teetsh/app/src/components/Img';

interface Props {
  url?: string;
  onClose: () => void;
}

export function PreviewModal(props: Props) {
  const { url, onClose } = props;
  return (
    <div>
      <Dialog
        isOpen={!!url}
        onClose={onClose}
        closeButton
        full
        size="2xl"
        disabledClickOutside={false}
      >
        <Dialog.Body>
          {url && <Img width={1800} s3Path={new URL(url).pathname} />}
        </Dialog.Body>
      </Dialog>
    </div>
  );
}
